import {createTypedReducerWithImmer} from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Draft } from "immer";

export interface CreateAccountFormState {
    fieldValues: SafeDictionary<string>;
}

export const initialState: CreateAccountFormState = {
    fieldValues: {},
};


export const customCreateAccountReducer = createTypedReducerWithImmer(initialState, {
    "Custom/CreateAccountForm/ClearForm": (draft: Draft<CreateAccountFormState>) => {
        draft.fieldValues = {};
    },
    "Custom/CreateAccountForm/SetFieldValue": (
        draft: Draft<CreateAccountFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
});

// export default createTypedReducerWithImmer(initialState, customCreateAccountReducer);
